<script lang="js">
import { defineComponent, ref, watch, onMounted, toRefs } from 'vue-demi';
import { mapGetters } from 'vuex';
import { useDealerBusiOrder, usePhoneProtected } from '@auto/dealer-busi-order';
import { OrderService } from '../../services/order.service';
import utils from '../../utils/util';
import layerManager from '../../services/layer.manager';
import queryParams from '../../services/pageQuery.service';
import SmartIntercept from '../../services/smartIntercept.service';
import * as layerNames from '../../services/layerName';
import Layer from '../Layer.vue';
import store from '../../store';
import orderApi from '../../apis/order.api';
import redPacketsProxy from '../../services/actionSync/red.packet.proxy';
import { DefaultAgreementInfo } from '@auto/dealer-order-agreement';
import { useAgreeMent } from '../../services/agreement.service';
import eventBus from '@/services/eventBus.service';
export default defineComponent({
  components: {
    Layer,
  },
  props: {
    dealerId: {
      type: Number,
      required: true,
    },
    promotionId: {
      type: String,
      default: '',
    },
    redPacketsTypeId: {
      type: Number,
      required: true,
    },
    seriesId: {
      type: Number,
      required: 0,
    },
    elementId: {
      type: String,
      default: '2|1211004|897|18491|205073|303809',
    },
  },
  setup (props) {
    const {dealerId,promotionId,redPacketsTypeId,seriesId,elementId} = toRefs(props)
    function setRedPacketCookie () {
      const name = 'hideRedPacketTwoHours_' + dealerId.value;
      const hideRedPacket = utils.getCookie(name);
      if (!hideRedPacket) {
        utils.setCookie({
          name: 'hideRedPacketTwoHours_' + dealerId.value,
          value: 'true',
          time: 2 * 60 * 60 * 1000
        });
      }
    }
    const disabled = ref(false);
    const visible = ref(true);
    const deviceId = utils.getCookie('app_deviceid') || '-1';
    const env = process.env.NODE_ENV !== 'production' ? 'test' : 'prod';
    const order = useDealerBusiOrder({
      deviceId: deviceId,
      time: 60,
      appId: 'dealer.vr',
      source: 'dealer.vr',
      env: env,
    });
    const redPacketInfo = ref({});
    const loaded = ref(false);
    orderApi.getRedPacketInfoByPromotionId(promotionId.value, redPacketsTypeId.value).then(data => {
      if (data) {
        redPacketInfo.value = data;
        loaded.value = true;
      }
    });

    function showRule () {
      setTimeout(() => {
        layerManager.open(layerNames.RED_PACKET_RULE_LAYER, {
          propsData: { rules: redPacketInfo.value.rule },
        });
      }, 300);
    }
    function originSuccessResult(smartIntercept,data){
       // 非主app环境不走竞品逻辑
      if(!utils.isApp()){
        setTimeout(() => {
          redPacketsProxy.successResult();
          layerManager.open(layerNames.RED_PACKET_SUCCESS_LAYER, {
            propsData: { orderResult: data, userPhone: order.orderData.phone },
          });
        }, 300);
      }else{
        smartIntercept.getRecommendAdFn(seriesId.value).then((res) => {
          if (res.length) {
            const postData = {
              seriesId:seriesId.value,
              phone:order.orderData.phone,
              name:order.orderData.userName,
              realDealerId:
                res[0].dealerIds && res[0].dealerIds.length
                  ? res[0].dealerIds
                  : [res[0].dealerId],
            }
            smartIntercept.getOrderInfo(postData);
            smartIntercept.getRandomInt(10, 20);
            setTimeout(() => {
              layerManager.open(layerNames.RED_PACKET_SUCCESS_LAYER_NEW, {
                propsData: {
                    orderResult: data,
                    redPacketInfo: res[0],
                    smartIntercept: smartIntercept,
                    order: smartIntercept.order,
                    userPhone: order.orderData.phone,
                    package:{
                      cityId,
                      pvAreaId:queryParams.pvAreaId,
                      deviceId
                    }
                },
              });
            }, 300);
          }else{
            setTimeout(() => {
              redPacketsProxy.successResult();
              layerManager.open(layerNames.RED_PACKET_SUCCESS_LAYER, {
                propsData: { orderResult: data, userPhone: order.orderData.phone },
              });
            }, 300);
          }
        })
      }
    }
    function showSuccessResult (postData,data) {
      visible.value = false;
      const smartIntercept = new SmartIntercept(store.state.baseInfo);
      originSuccessResult(smartIntercept,data);
    }
    function showFailResult () {
      visible.value = false;
      setTimeout(() => {
        layerManager.open(layerNames.RED_PACKET_FAILED_LAYER, {
          propsData: {},
        });
      }, 300);
    }
    function handleClose (manual = true) {
      if (manual) {
        eventBus.$emit('toggleGuide','play')
        redPacketsProxy.close();
      }
      visible.value = false;

    }
    order.orderData.dealerIds = [dealerId.value];
    order.orderData.seriesIds = [seriesId.value];

    const phoneInput = usePhoneProtected(order.orderData);
    const cityId = store.state.baseInfo.cityId;
    const agreement = useAgreeMent(
      env,
      '',
      order.orderData,
      cityId,
    );

    const orderService = new OrderService(
      queryParams.pvAreaId,
      cityId,
    );
    // 红包入口
    function submitOrderForm () {
      const validResult = order.valid();
      if (validResult) {
        layerManager.toast(
          { propsData: { message: validResult.message } },
          2000,
          );
        return;
      }
      if (!agreement.agreementChecked.value) {
        layerManager.toast(
            { propsData: { message: agreement.tipText } },
            2000,
          );
        return;
      }
      if (disabled.value) {
        return;
      }
      disabled.value = true;
      const vrSalesInfo = store.state.sales.vrSalesInfo;
      orderService
        .createRedPacketOrder({
          ...order.orderData,
          deviceId,
          elementId: elementId.value,
          salesId: vrSalesInfo.salesId,
          extendField: { channelId: vrSalesInfo.channelId , channelType: vrSalesInfo.channelId ? 1 : 0 },
          promotionId: promotionId.value,
          redPacketType: redPacketsTypeId.value,
        })
        .then((result) => {
          order.orderData.smsCode = '';
          disabled.value = false;
          if (result && result.length > 0) {
            const data = result[0];
            data.usePhone = order.orderData.phone;
            const postData = {
              sourceId: 29,
              seriesId: seriesId.value,
              cityId: cityId,
              id: deviceId,
              type:'app'
            }
            showSuccessResult(postData,data);
          } else {
            showFailResult();
          }
          order.savePhoneName();
          order.needSmsCode();
          handleClose(false);
        })
        .catch((ex) => {
          order.orderData.smsCode = '';
          disabled.value = false;
          layerManager.toast({ propsData: { message: ex.message } }, 2000);
          order.savePhoneName();
          order.needSmsCode();
        });
    }
    function imageCodeLayerConfirm (imgCode) {
      order.orderData.imageVCode = imgCode;
      order.sendSms().then((sended) => {
        order.orderData.imageVCode = '';
        order.orderData.smsCode = '';
        if (sended) {
          imageCodeLayerClose();
        }
      });
    }
    order.onError(({ name, error }) => {
      console.log('order-error', name, error);
      layerManager.toast({ propsData: { message: error.message } }, 2000);
    });
    function imageCodeLayerClose () {
      order.orderUI.showImageVCode = false;
    }

    const openProtocal = () =>
      layerManager.open(layerNames.PROTOCAL, {
        propsData: {
          title: '',
          src: DefaultAgreementInfo.agreementUrl,
        },
      });
    watch(
      () => order.orderUI.showImageVCode,
      () => {
        if (order.orderUI.showImageVCode) {
          layerManager.open(layerNames.RED_PACKET_IMG_CODE_LAYER, {
            propsData: {
              orderUI: order.orderUI,
              refreshImgCode: () => {
                order.refreshImgCode();
              },
              confirmImgCode: (imgCode) => {
                imageCodeLayerConfirm(imgCode);
              },
              closeImgCode: imageCodeLayerClose,
            },
          });
        }
      },
      { immediate: true },
    );
    onMounted(() => {
      setRedPacketCookie();
    });
    return {
      disabled,
      ...order,
      openProtocal,
      ...phoneInput,
      showRule,
      imageCodeLayerConfirm,
      imageCodeLayerClose,
      submitOrderForm,
      handleClose,
      layerName: layerNames.RED_PACKET_FORM_LAYER,
      visible,
      loaded,
      redPacketInfo,
      agreementInfo:DefaultAgreementInfo,
      toggleAgreementChecked: agreement.toggleAgreementChecked,
      agreementChecked: agreement.agreementChecked,
    };
  },
});
</script>
<template>
  <!-- 弹窗红包 -->
  <Layer
    :layerName="layerName"
    :visible="visible"
    maskDirection="Middle"
    v-if="loaded"
  >
    <div class="dlrLayer-middle dlrRedPackNew dlrRedPackNew-maxBg">
      <div class="dlrRedPackNew-cont">
        <div class="dlrRedPackNew-bg">
          <div class="dlrRedPackNew-top">
            <div class="dlrRedPackNew-top-title">
              <p>{{ redPacketInfo.title }}</p>
              <a href="javascript:void(0);" @click="showRule">规则</a>
            </div>
            <p class="money">
              <strong>{{ redPacketInfo.money }}</strong>
              <sub>元</sub>
            </p>
            <p class="text-1">
              {{ redPacketInfo.typeName }}
            </p>
            <p class="text-4">
              {{ redPacketInfo.ruleType === 1 ? '' : '不' }}可与店内优惠叠加使用
            </p>
          </div>
          <div class="dlrForm">
            <ul class="dlrFormul">
              <li class="dlrState-current">
                <p class="dlrFormul-name">您的姓名</p>
                <div class="dlrFormul-card">
                  <p class="dlrFormul-card-text">
                    <input
                      v-model="orderData.userName"
                      type="text"
                      maxlength="10"
                      class="dlrFormul-inpText"
                      placeholder="请输入您的姓名"
                    />
                  </p>
                </div>
              </li>
              <li class="dlrState-current">
                <p class="dlrFormul-name">手机号码</p>
                <div class="dlrFormul-card">
                  <p class="dlrFormul-card-text">
                    <input
                      v-model="encryptedPhone"
                      type="tel"
                      maxlength="11"
                      class="dlrFormul-inpText"
                      placeholder="请输入手机号码"
                      @focus="showInputPhone"
                      @blur="showEncryptedPhone"
                    />
                  </p>
                </div>
                <p class="dlrFormul-other">
                  <i
                    v-show="orderData.phone"
                    class="dlrFormul-icon iconFork"
                    @click="clearPhone"
                  ></i>
                </p>
                <p class="dlrFormul-other">
                  <i class="dlrFormul-icon iconShield"></i>
                </p>
              </li>
              <li v-show="orderUI.showSmsCode">
                <p class="dlrFormul-name">短信验证</p>
                <div class="dlrFormul-card">
                  <p class="dlrFormul-card-text">
                    <input
                      v-model="orderData.smsCode"
                      maxlength="6"
                      type="tel"
                      class="dlrFormul-inpText"
                      placeholder="请输入验证码"
                    />
                  </p>
                </div>
                <p
                  v-stat:click="{ action: 'order_red_packet_send_sms_click' }"
                  class="dlrFormul-other"
                  @click="sendSms"
                >
                  <a
                    v-if="orderUI.sendSmsCount === 0"
                    class="dlrFormul-other-code"
                    >获取验证码</a
                  >
                  <span
                    v-else-if="orderUI.remainTimes"
                    class="dlrFormul-other-code"
                    @click.stop=""
                  >
                    <em>{{ orderUI.remainTimes }}s后重新发送</em>
                  </span>
                  <span v-else class="dlrFormul-other-code">重新发送</span>
                </p>
              </li>
            </ul>
            <div class="dlrForm-footer">
              <a
                v-stat:click="{ action: 'order_red_packet_create_click' }"
                class="dlrForm-bnt"
                href="javaScript:void(0);"
                :class="{ disabled: disabled }"
                @click="submitOrderForm"
              >
                <span>{{ redPacketInfo.buttonText }}</span>
              </a>
              <div
                v-stat:click="{ action: 'order_agreement_click' }"
                class="dlrForm-agreement"
                @click="toggleAgreementChecked"
              >
                <label>
                  <input
                    type="checkbox"
                    class="dlrCheckbox"
                    :checked="agreementChecked"
                  />已阅读并同意
                </label>
                <a
                  class="agreement"
                  href="javaScript:void(0);"
                  @click.stop="openProtocal"
                >
                  {{ agreementInfo.agreementDesc }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <span class="dlrRedPackNew-close" @click="handleClose"></span>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>

<style lang="scss">
@import './scss/Form.scss';
// @import './scss/Rule.scss';
</style>
